var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-box"},[_c('img',{staticStyle:{"height":"100px"},attrs:{"src":require("@images/center/recom.png"),"alt":""}}),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.emptyTip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }